import { Component } from "react"

/* Components */
import { Input } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { create, edit } from "../../api/Studio"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { CloseIcon, StudioIcon, EditIcon, ServerIcon, InfoIcon } from "./StudioIcons"

/* Sweet alert */
import Swal from "../../helpers/alert"


/* EMPTY FORM STATE */
const EMPTY = {
    type: "create",
    id: 0,
    name: "",
    slug: "",
    serviceURL: "",
    socketURL: "",
    recordURL: "",
    waiting: false,
}


/* Widget Studio Form */
class StudioForm extends Component {

    constructor() {
        super()
        this.state = { visible: false, ...EMPTY }
    }

    /* Open Action */
    open = ({ id, type, name, slug, serviceURL, socketURL, recordURL }) => {
        this.setState({
            visible: true,
            ...EMPTY,
            type: utils.checkValue(type, "create"),
            id: utils.checkValue(id, 0),
            name: utils.checkValue(name, ""),
            slug: utils.checkValue(slug, ""),
            serviceURL: utils.checkValue(serviceURL, ""),
            socketURL: utils.checkValue(socketURL, ""),
            recordURL: utils.checkValue(recordURL, ""),
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, ...EMPTY })
    }

    /* Error Message Of A Response */
    message = (response) => {

        /* Check Message */
        if (response && response.data && response.data.message) {
            return response.data.message
        }

        /* Check Status */
        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        /* Check Status */
        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        /* Send Result */
        return t("swal.generic")
    }

    /* Save Action */
    save = () => {

        /* Fields */
        const { id, type, name, slug, serviceURL, socketURL, recordURL, waiting } = this.state
        const { reload } = this.props

        /* Check Waiting */
        if (waiting) {
            return
        }

        /* Check Name */
        if (!name) {
            this._name.error(t("studio.error.emptyName"))
            return
        }

        /* Check Code */
        if (!slug) {
            this._slug.error(t("studio.error.emptyCode"))
            return
        }

        /* Check Service URL */
        if (!serviceURL) {
            this._serviceURL.error(t("studio.error.emptyServiceURL"))
            return
        }

        /* Check Socket URL */
        if (!socketURL) {
            this._socketURL.error(t("studio.error.emptySocketURL"))
            return
        }

        /* Start Waiting */
        this.setState({ waiting: true })

        /* Prepare Request */
        const request = type === "edit"
            ? edit({ id, name, slug, serviceURL, socketURL, recordURL })
            : create({ name, slug, serviceURL, socketURL, recordURL })

        /* Send to REST API */
        request.then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(type === "edit" ? t("studio.savedSuccess") : t("studio.createdSuccess"), "success"))
                reload()
                this.close()
            }
            else {
                Swal.fire(utils.notification(this.message(response), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    render = () => {

        /* Fields */
        const { visible, type, name, slug, serviceURL, socketURL, recordURL, waiting } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="std--modal"
                overlayClassName="std--overlay"
                closeTimeoutMS={200}
            >

                <div className="std--modal-header">

                    <div className="std--modal-icon">
                        {type === "edit" ? <EditIcon size={18} /> : <StudioIcon size={18} />}
                    </div>

                    <div className="std--modal-head-text">
                        <h2>{type === "edit" ? t("studio.editTitle") : t("studio.createdTitle")}</h2>
                        <p>{type === "edit" ? t("studio.editSubtitle") : t("studio.createSubtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="std--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="std--modal-body">

                    <div className="std--section">

                        <div className="std--section-head">
                            <div className="std--section-title">
                                <StudioIcon size={13} />
                                {t("studio.mainSection")}
                            </div>
                        </div>

                        <Input ref={(ref) => this._name = ref} label={t("studio.nameLabel")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                        <Input ref={(ref) => this._slug = ref} label={t("studio.codeLabel")} value={slug} onChange={(event) => this.setState({ slug: event.target.value })} />

                    </div>

                    <div className="std--section">

                        <div className="std--section-head">
                            <div className="std--section-title">
                                <ServerIcon size={13} />
                                {t("studio.addressSection")}
                            </div>
                        </div>

                        <Input ref={(ref) => this._serviceURL = ref} label="Service URL" value={serviceURL} onChange={(event) => this.setState({ serviceURL: event.target.value })} />
                        <Input ref={(ref) => this._socketURL = ref} label="Socket URL" value={socketURL} onChange={(event) => this.setState({ socketURL: event.target.value })} />
                        <Input ref={(ref) => this._recordURL = ref} label="Record URL" value={recordURL} onChange={(event) => this.setState({ recordURL: event.target.value })} />

                        <div className="std--hint">
                            <InfoIcon />
                            <span>{t("studio.addressHint")}</span>
                        </div>

                    </div>

                </div>

                <div className="std--modal-footer">

                    <div onClick={() => this.close()} className="std--button ghost">{t("common.cancel")}</div>

                    <div onClick={() => this.save()} className={`std--button primary ${waiting ? "waiting" : ""}`}>
                        {waiting ? <div className="std--loading small" /> : t("common.save")}
                    </div>

                </div>

            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(StudioForm)
